//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Icon from '@components/atoms/icon/Icon';
import { SubsectionText } from '@components/atoms/text/Text';
import { SmallTooltip } from '@components/molecules/tooltip/Tooltip';
import {
  getIsOnePageWorkflow,
  getIsTributaryWorkflow,
} from '@uia/products/selectors/getUIAReactPortItemProducts';

export const WorkflowTooltips = () => {
  const isTributaryWorkflow = useSelector(getIsTributaryWorkflow);
  const isOnePageWorkflow = useSelector(getIsOnePageWorkflow);

  return (
    <>
      {isTributaryWorkflow && (
        <>
          <InfoTooltip>
            <Subtitle>
              Showroom
              <SmallTooltip
                content='A Showroom is a mobile webpage generated to create a continuous browsing experience based on the selected content and its tagged products.'
                target={<Icon name='info' />}
              />
            </Subtitle>
          </InfoTooltip>
          <InfoTooltip>
            <Subtitle>
              Add Products
              <SmallTooltip
                content='Add products to your content. These products will appear with your content when visitors access your Showroom.'
                target={<Icon name='info' />}
              />
            </Subtitle>
          </InfoTooltip>
        </>
      )}
      {isOnePageWorkflow && (
        <>
          <InfoTooltip>
            <Subtitle>
              ONE Page
              <SmallTooltip
                content='A Bazaarvoice ONE Page is a dynamic landing page integrated onto your website which displays shoppable, lifestyle imagery along with AI-powered content and product recommendations.'
                target={<Icon name='info' />}
              />
            </Subtitle>
          </InfoTooltip>
          <InfoTooltip>
            <Subtitle>
              Add products
              <SmallTooltip
                content='Add products to your content. These products will appear with your content when visitors access your ONE Page.'
                target={<Icon name='info' />}
              />
            </Subtitle>
          </InfoTooltip>
        </>
      )}
    </>
  );
};

const Subtitle = styled(SubsectionText)(
  ({ theme }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    gap: ${theme.spacings[1]};
  `,
);

const InfoTooltip = styled.div(
  () => `
    display: flex;
    justify-content: start;
    align-items: center;
  `,
);
